import { CACHE_PROFILES } from "@/config/query-cache"
import { useTransportQuery } from "@/transport"

/**
 * Fetches the SimulationDataFrames materialization schema: every frame table a
 * SQL metric query can run against, its columns, and the enum metadata for
 * enum-typed columns. Served org-agnostically from the backend frame
 * materializers, so the Custom SQL config no longer hardcodes (and drifts from)
 * the schema.
 */
export function useSimulationDataFramesSchemaTransport() {
  return useTransportQuery({
    operation: "getSimulationDataFramesSchema",
    options: CACHE_PROFILES.lookup,
  })
}
